import React from 'react';
import {Navigate, Route} from 'react-router-dom';
import Header from '../pages/Common/Header/Header';
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import LoadingPage from '../pages/Loading/LoadingPage';
import MaintenancePage from '../pages/MaintenancePage/MaintenancePage';
import OfferCardPage from '../pages/OfferCardPage/OfferCardPage';
import ReviewOfferPage from '../pages/ReviewOfferPage/ReviewOfferPage';
import TermsConditionsPage from '../pages/Terms&ConditionsPage/Terms&ConditionsPage';

import {openWindow} from '../utils/windowUtils';
import PrequalReview from '../pages/PrequalSinglePageApp/PrequalReview/PrequalReview';

export function ApplyRoute() {
  return <Navigate to='/' state={{isFromApply: true}} replace />;
}
export function sharedRoutes(props) {
  const {customerData} = props;

  return (
    <>
      <Route path='/apply' element={<ApplyRoute />} />
      <Route
        path='/review'
        element={
          <div className='prequal--web--form-container'>
            <PrequalReview {...props} />
          </div>
        }
      />
      <Route path='/review-offer' element={<ReviewOfferPage {...props} />} />
      <Route path='/offer-card' element={<OfferCardPage {...props} />} />
      <Route path='/error' element={<ErrorPage {...props} />} />
      <Route path='/maintenance' element={<MaintenancePage {...props} openWindow={openWindow} />} />
      <Route
        path='/offer-loading'
        element={
          <>
            <div className='prequal--web--hide-desktop'>{!customerData.isDealerHostApplication.value && <Header />}</div>
            <LoadingPage {...props} />
          </>
        }
      />
      <Route path='/terms-and-conditions' element={<TermsConditionsPage />} />
    </>
  );
}
